<form [formGroup]="formGroup" *ngIf="invoiceDirection$ | async as invoiceDirection">



  <fieldset *ngIf="fieldsConfig?.journal?.visible !== false">
    <legend>Journal</legend>
    <mat-form-field class="third-width" *ngIf="fieldsConfig?.journal?.code?.visible !== false">
      <mat-label>Code Journal</mat-label>
      <input matInput formControlName="journalCode" [placeholder]="fieldsConfig?.journal?.code?.defaultValue || ''">
    </mat-form-field>
    <mat-form-field class="two-thirds-width" *ngIf="fieldsConfig?.journal?.label?.visible !== false && configurationMode === 'EXPERT'">
      <mat-label>Libellé Journal</mat-label>
      <input matInput formControlName="journalLabel" [placeholder]="fieldsConfig?.journal?.label?.defaultValue || ''">
    </mat-form-field>
  </fieldset>

  <fieldset *ngIf="fieldsConfig?.thirdPartyAccount?.visible !== false">
    <legend>{{ invoiceDirection === 'SELL' ? 'Clients' : 'Fournisseurs' }}</legend>
    <app-third-party-processor-configuration
      [fieldsConfiguration]="fieldsConfig?.thirdPartyAccount"
      [thirdPartyAccount]="invoiceConfig?.thirdPartyAccount"
      [toolLabel]="toolLabel"
      [thirdPartyType]="invoiceDirection === 'SELL' ? 'CLIENT' : 'SUPPLIER'"
      #thirdPartyAccount
  ></app-third-party-processor-configuration>
  </fieldset>



  <fieldset *ngIf="fieldsConfig?.generation?.visible !== false || fieldsConfig?.generation?.useSuggestedProductsAccounts?.visible !== false">
    <legend>{{ invoiceDirection === 'SELL' ? 'Produits' : 'Charges' }}</legend>

    <div class="row" *ngIf="fieldsConfig?.generation?.useSuggestedProductsAccounts?.visible !== false">
      <mat-slide-toggle formControlName="useSuggestedProductsAccounts">
        <div>
          <span>Utiliser la configuration {{ toolLabel }} des comptes de {{ invoiceDirection === 'SELL' ? 'produits' : 'charges' }}</span>
        </div>
      </mat-slide-toggle>
    </div>

    <div class="row" *ngIf="fieldsConfig?.generation?.option?.visible !== false">
      <mat-form-field class="full-width" *ngIf="formGroup.value.generationOption === null || configurationMode !== 'STANDARD'">
        <mat-label>Répartition des lignes de {{ invoiceDirection === 'SELL' ? 'produit' : 'charge' }}</mat-label>
        <mat-select formControlName="generationOption" [compareWith]="compareFunction">
          <mat-option *ngFor="let option of invoiceGenerationOptions" [value]="option.value">{{option.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    
    <div class="row dark-info" *ngIf="formGroup.value.useSuggestedProductsAccounts === true">
      <span
        matTooltip="En cas de configuration manquante dans {{ toolLabel }}, la configuration suivante sera utilisée."
        matTooltipPosition="right"
      >
        <b>Configuration de secours</b>
      </span>
    </div>

    <ng-container *ngIf="formGroup.value.generationOption === 'ONE_LINE_PER_VAT_RATE'">
      <app-vat-account-configuration
        [fieldsConfiguration]="fieldsConfig?.generation?.oneLinePerVatRate?.productVats"
        [vatAccounts]="invoiceConfig?.productVatAccounts"
        [toolLabel]="toolLabel"
        [addLabel]="invoiceDirection === 'SELL' ? 'Ajouter un compte de produit' : 'Ajouter un compte de charge'"
        [configMode]="configurationMode"
        [defaultLabelPrefix]="invoiceDirection === 'SELL' ? 'Ventes TVA' : 'Charges TVA'"
        [fetchedAccountsInput]="invoiceDirection === 'SELL' ? fetchedFieldsConfiguration?.vatAccountsConfiguration?.productVats : undefined"
        #productVatAccounts
      ></app-vat-account-configuration>
    </ng-container>
    <ng-container *ngIf="formGroup.value.generationOption === 'ONE_LINE_PER_INVOICE_LINE' || formGroup.value.generationOption === 'ONE_LINE_PER_PRODUCT_ACCOUNT'">
      <app-vat-account-configuration
        [fieldsConfiguration]="fieldsConfig?.generation?.oneLinePerInvoiceLine?.productVats"
        [vatAccounts]="invoiceConfig?.productVatAccounts"
        [toolLabel]="toolLabel"
        [addLabel]="invoiceDirection === 'SELL' ? 'Ajouter un compte de produit' : 'Ajouter un compte de charge'"
        [configMode]="configurationMode"
        [fetchedAccountsInput]="invoiceDirection === 'SELL' ? fetchedFieldsConfiguration?.vatAccountsConfiguration?.productVats : undefined"
        [defaultLabelPrefix]="invoiceDirection === 'SELL' ? 'Ventes TVA' : 'Charges TVA'"
        #productVatAccounts
      ></app-vat-account-configuration>
    </ng-container>
    <ng-container *ngIf="formGroup.value.generationOption === 'ONE_GLOBAL_LINE'">
      <div class="row" *ngIf="fieldsConfig?.generation?.oneGlobalLine?.product?.visible !== false">
        <mat-form-field class="third-width" *ngIf="fieldsConfig?.generation?.oneGlobalLine?.product?.account?.visible !== false">
          <mat-label>Produit</mat-label>
          <input matInput formControlName="productAccount" [placeholder]="fieldsConfig?.generation?.oneGlobalLine?.product?.account?.defaultValue || ''">
        </mat-form-field>
        <mat-form-field class="two-thirds-width" *ngIf="fieldsConfig?.generation?.oneGlobalLine?.product?.label?.visible !== false && configurationMode === 'EXPERT'">
          <mat-label>Libellé</mat-label>
          <input matInput formControlName="productAccountLabel" [placeholder]="fieldsConfig?.generation?.oneGlobalLine?.product?.label?.defaultValue || ''">
        </mat-form-field>
      </div>
    </ng-container>
  </fieldset>



  <fieldset>
    <legend>{{ invoiceDirection === 'SELL' ? 'TVA collectée' : 'TVA déductible' }}</legend>

    <div class="row" *ngIf="fieldsConfig?.useSuggestedVatsAccounts?.visible !== false">
      <mat-slide-toggle formControlName="useSuggestedVatsAccounts">
        <div>
          <span>Utiliser la configuration {{ toolLabel }} des comptes de TVA</span>
        </div>
      </mat-slide-toggle>
    </div>
    
    <div class="row dark-info" *ngIf="formGroup.value.useSuggestedVatsAccounts === true">
      <span
        matTooltip="En cas de configuration manquante dans {{ toolLabel }}, la configuration suivante sera utilisée."
        matTooltipPosition="right"
      >
        <b>Configuration de secours</b>
      </span>
    </div>

    <app-vat-account-configuration
      [fieldsConfiguration]="fieldsConfig?.collectedVats"
      [vatAccounts]="invoiceConfig?.collectedVatAccounts"
      [toolLabel]="toolLabel"
      [configMode]="configurationMode"
      [fetchedAccountsInput]="invoiceDirection === 'SELL' ? fetchedFieldsConfiguration?.vatAccountsConfiguration?.collectedVats : fetchedFieldsConfiguration?.vatAccountsConfiguration?.deductibleVats"
      addLabel="Ajouter un compte de TVA"
      [defaultLabelPrefix]="invoiceDirection === 'SELL' ? 'TVA collectée' : 'TVA déductible'"
      #collectedVatAccounts
    ></app-vat-account-configuration>

    <mat-divider *ngIf="fieldsConfig?.amountDifferenceOption?.visible !== false && configurationMode !== 'STANDARD'"></mat-divider>

    <div class="row" *ngIf="fieldsConfig?.amountDifferenceOption?.visible !== false">
      <mat-form-field class="full-width" *ngIf="configurationMode !== 'STANDARD'">
        <mat-label>Gestion des écarts HT/TVA/TTC</mat-label>
        <mat-select formControlName="amountDifferenceOption" [compareWith]="compareFunction">
          <mat-option *ngFor="let option of invoiceAmountDifferenceOptions" [value]="option.value">{{option.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row" *ngIf="formGroup.value.amountDifferenceOption === 'USE_ACCOUNTS' && fieldsConfig?.debitAdjustment?.visible !== false && configurationMode !== 'STANDARD'">
      <mat-form-field class="third-width" *ngIf="fieldsConfig?.debitAdjustment?.account?.visible !== false">
        <mat-label>Charges diverses de gestion courante</mat-label>
        <input matInput formControlName="debitAdjustmentAccount" [placeholder]="fieldsConfig?.debitAdjustment?.account?.defaultValue || ''">
      </mat-form-field>
      <mat-form-field class="two-thirds-width" *ngIf="fieldsConfig?.debitAdjustment?.label?.visible !== false">
        <mat-label>Libellé charges diverses de gestion courante</mat-label>
        <input matInput formControlName="debitAdjustmentAccountLabel" [placeholder]="fieldsConfig?.debitAdjustment?.label?.defaultValue || ''">
      </mat-form-field>
    </div>
    <div class="row" *ngIf="formGroup.value.amountDifferenceOption === 'USE_ACCOUNTS' && fieldsConfig?.creditAdjustment?.visible !== false && configurationMode !== 'STANDARD'">
      <mat-form-field class="third-width" *ngIf="fieldsConfig?.creditAdjustment?.account?.visible !== false">
        <mat-label>Produits divers de gestion courante</mat-label>
        <input matInput formControlName="creditAdjustmentAccount" [placeholder]="fieldsConfig?.creditAdjustment?.account?.defaultValue || ''">
      </mat-form-field>
      <mat-form-field class="two-thirds-width" *ngIf="fieldsConfig?.creditAdjustment?.label?.visible !== false">
        <mat-label>Libellé produits divers de gestion courante</mat-label>
        <input matInput formControlName="creditAdjustmentAccountLabel" [placeholder]="fieldsConfig?.creditAdjustment?.label?.defaultValue || ''">
      </mat-form-field>
    </div>
  </fieldset>



  <fieldset [ngClass]="{'hide': configurationMode === 'STANDARD' || (fieldsConfig?.entryLineDescription?.visible === false && fieldsConfig?.entryDescription?.visible === false && fieldsConfig?.groupingDescription?.visible === false && fieldsConfig?.documentRef?.visible === false)}">
    <legend>Libellés</legend>

    <div class="row" *ngIf="fieldsConfig?.documentRef?.visible !== false && configurationMode !== 'STANDARD'">
      <mat-form-field class="full-width">
        <mat-label>Référence des pièces {{ invoiceDirection === 'SELL' ? 'de vente' : 'd’achat' }}</mat-label>
        <mat-select  formControlName="documentRefOption" [compareWith]="compareFunction">
          <mat-option *ngFor="let option of fieldsConfig?.documentRef?.options" [value]="option.value">{{option.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <app-description-configuration
      descriptionOptionLabel="Regroupement des écritures"
      descriptionTemplateLabel="Regroupement avancé"
      [fieldsConfiguration]="fieldsConfig?.groupingDescription"
      [descriptionConfiguration]="invoiceConfig?.groupingDescription"
      [configMode]="configurationMode"
      #groupingDescription
    ></app-description-configuration>

    <app-description-configuration
      descriptionOptionLabel="Libellé de l'écriture"
      descriptionTemplateLabel="Libellé personnalisé"
      [fieldsConfiguration]="fieldsConfig?.entryDescription"
      [descriptionConfiguration]="invoiceConfig?.entryDescription"
      [configMode]="configurationMode"
      #entryDescription
    ></app-description-configuration>

    <app-description-configuration
      descriptionOptionLabel="Libellé des lignes"
      descriptionTemplateLabel="Libellé personnalisé"
      [fieldsConfiguration]="fieldsConfig?.entryLineDescription"
      [descriptionConfiguration]="invoiceConfig?.entryLineDescription"
      [configMode]="configurationMode"
      #entryLineDescription
    ></app-description-configuration>
  </fieldset>
</form>